import { Box, Button, CircularProgress, IconButton } from '@mui/material';
import { createMRTColumnHelper } from 'material-react-table';
import React, { useState } from 'react';
import CummonTable from '../../Common/CummonTable';
import secureLocalStorage from 'react-secure-storage';
import Swal from 'sweetalert2';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from 'react-router-dom';

const AgentList = ({ data, refetch, setRefetch }) => {
  const navigate = useNavigate();
  const adminInfo = secureLocalStorage.getItem('admin-info');
  const token = adminInfo.token;
  const columnHelper = createMRTColumnHelper();
  const [rowLoading, setRowLoading] = useState({});

  const columns = [
    columnHelper.accessor('agentId', {
      header: 'Agent Id',
      size: 1,
      Cell: ({ row }) => (
        <Box>
          <Button
            onClick={() =>
              navigate('/dashboard/agentdetails', {
                state: row.original,
              })
            }
            style={{
              width: '70%',
              background: 'gray',
              color: 'white',
              fontSize: '12px',
              textTransform: 'capitalize',
              padding: '2px 1px',
            }}
          >
            {row.original?.agentId}
          </Button>
        </Box>
      ),
    }),
    columnHelper.accessor('name', {
      header: 'Agent Name',
      size: 10,
    }),
    columnHelper.accessor('status', {
      size: 1,
      header: 'Status',
      Cell: ({ row }) => (
        <Box className={`${row.original.status?.toLowerCase()}-btn`}>
          {row.original.status}
        </Box>
      ),
    }),

    columnHelper.accessor('company', {
      header: 'Company',
    }),
    columnHelper.accessor('address', {
      header: 'Address',
    }),
    columnHelper.accessor('email', {
      header: 'Email',
    }),
    columnHelper.accessor('phone', {
      size: 1,
      header: 'Phone',
    }),
    columnHelper.accessor('active', {
      header: 'Operation',
      Cell: ({ row }) => (
        <Box>
          {row.original.status === 'active' ? (
            <button
              style={{
                backgroundColor: '#E1241A',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '3px',
                width: '73px',
                height: '30px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
              onClick={() => handleActive(row.original, 'deactive')}
              disabled={rowLoading[row.original.uid]}
            >
              {rowLoading[row.original.uid] ? (
                <CircularProgress style={{ height: '15px', width: '15px' }} />
              ) : (
                'Deactivate'
              )}
            </button>
          ) : row.original?.status === 'reject' ? (
            <button
              disabled
              style={{
                backgroundColor: 'var(--gray)',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '3px',
                width: '73px',
                height: '30px',
                fontSize: '12px',
              }}
            >
              Reject
            </button>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'start' }}>
              <IconButton
                sx={{ color: '#0E8749' }}
                onClick={() => handleActive(row.original, 'active')}
                disabled={rowLoading[row.original.uid]}
              >
                {rowLoading[row.original.uid] ? (
                  <CircularProgress style={{ height: '15px', width: '15px' }} />
                ) : (
                  <CheckCircleIcon />
                )}
              </IconButton>
              <IconButton
                sx={{ color: 'var(--remove-color)' }}
                onClick={() => handleActive(row.original, 'reject')}
                disabled={rowLoading[row.original.uid]}
              >
                {rowLoading[row.original.uid] ? (
                  <CircularProgress style={{ height: '15px', width: '15px' }} />
                ) : (
                  <CancelIcon />
                )}
              </IconButton>
            </Box>
          )}
        </Box>
      ),
    }),
    columnHelper.accessor('details', {
      size: 1,
      header: 'Details',
      Cell: ({ row }) => (
        <Box>
          <Button
            onClick={() =>
              navigate('/dashboard/agentdetails', {
                state: row.original,
              })
            }
            style={{
              width: '100%',
              background: 'var(--secondary-color)',
              color: 'white',
              fontSize: '12px',
              textTransform: 'capitalize',
              padding: '3px 1px',
            }}
          >
            Details
          </Button>
        </Box>
      ),
    }),
  ];

  const handleActive = async (items, status) => {
    const url = `https://api-b2b.fasttracktourism.com/admin/agent/${items?.uid}`;

    let body = JSON.stringify({
      email: items?.email,
      company: items?.company,
      status: status,
      password: '12345678',
      markuptype: items?.markuptype,
      markup: items?.markup,
    });

    try {
      setRowLoading((prevLoading) => ({
        ...prevLoading,
        [items.uid]: true,
      }));
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: body,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: `Agent ${status} Successfully`,
        confirmButtonText: 'OK',
      }).then(function () {
        setRefetch(!refetch);
        setRowLoading((prevLoading) => ({
          ...prevLoading,
          [items.uid]: false,
        }));
      });
    } catch (error) {
      console.error('Error activating agent:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error.message,
        confirmButtonText: 'OK',
      }).then(function () {
        setRowLoading((prevLoading) => ({
          ...prevLoading,
          [items.uid]: false,
        }));
      });
    }
  };

  return (
    <div>
      <Box
        sx={{
          boxSizing: 'border-box',
        }}
      >
        <CummonTable data={data} columns={columns} pageSize={15} />
      </Box>
    </div>
  );
};

export default AgentList;
